// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Nunito Sans', 'Nunito Sans Fallback'"},"className":"__className_511796"};